export default function () {
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/tasks/tasksCtrl.js